module.exports = __webpack_public_path__ + "img/earth-asia.bced0ca4.svg";